module.exports = __webpack_public_path__ + "static/media/CS2 -- 3.3.903250e9.png";